import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbDateTimeCommonInput } from "abreact/input/date/AbDateTimeCommonInput";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { AbTime } from "abweb/utils/date/AbTime";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
import { DateUtils } from "abweb/utils/DateUtils";
import * as React from "react";
export let AbTimePrecision = /*#__PURE__*/function (AbTimePrecision) {
  AbTimePrecision[AbTimePrecision["MINUTES"] = 0] = "MINUTES";
  AbTimePrecision[AbTimePrecision["SECONDS"] = 1] = "SECONDS";
  return AbTimePrecision;
}({});
const inRange = (time, earliest, latest) => {
  const date = new Date();
  const timeDate = DateUtils.partialOverrideDate(date, time);
  return DateUtils.partialOverrideDate(date, earliest) <= timeDate && timeDate <= DateUtils.partialOverrideDate(date, latest);
};
const stringToTime = (s, parser) => {
  const parsed = parser.parse(s);
  if (ClassUtils.isInstanceOf(parsed, Date)) return AbTime.fromDate(parsed);
  return parsed;
};
const EXAMPLE = AbTime.fromData({
  hour: 23,
  minute: 59,
  second: 59
});
export function AbTimeInput(props) {
  const {
    className,
    earliestTime,
    latestTime,
    format,
    value,
    placeholder,
    ...rest
  } = props;
  const wrappedFormat = props.format ?? (props.precision === AbTimePrecision.SECONDS ? DateTimeUtils.TIME_WITH_SECONDS : DateTimeUtils.TIME_WITH_MINUTES);
  const earliest = props.earliestTime ?? AbTime.MIN_TIME;
  const latest = props.latestTime ?? AbTime.MAX_TIME;
  const wrappedValue = props.value ? AbTime.fromData(props.value) : undefined;
  const wrappedPlaceholder = placeholder ?? AbReactResources.timeInput_placeholder();
  const inRangeProp = React.useCallback(time => inRange(time, earliest, latest), [earliest, latest]);
  return /*#__PURE__*/React.createElement(AbDateTimeCommonInput, _extends({}, rest, {
    value: wrappedValue,
    className: ReactUtils.classNamesString([props.className, "ab-time-input"]),
    placeholder: wrappedPlaceholder,
    format: {
      format: time => wrappedFormat.format(AbTime.toDate(time)),
      parse: string => stringToTime(string, wrappedFormat),
      example: EXAMPLE
    },
    inRange: inRangeProp,
    getErrorString: (textIsValid, inRange) => {
      if (!textIsValid) return `${AbReactResources.timeInput_error_invalidFormat(AbTime.format(EXAMPLE, wrappedFormat))}`;
      if (!inRange) return AbReactResources.timeInput_error_outOfRange(AbTime.format(earliest, wrappedFormat), AbTime.format(latest, wrappedFormat));
      return "";
    },
    equals: (d1, d2) => d1.equals(d2),
    abRef: props.abRef
  }));
}
//# sourceMappingURL=AbTimeInput.js.map
